import {Box, makeStyles, Theme, Typography} from "@material-ui/core";
import {useAppDispatch} from "app/hooks";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import AddCategory from "./components/AddCategory";
import TableCategory from "./components/TableCategory";
import {fetchCategoryList} from "./managerCategorySlice";

export interface ManagerCategoryProps {}

export default function ManagerCategory(props: ManagerCategoryProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    background: {
      background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
      borderRadius: 24,
      padding: "32px 36px",
      color: "#FFFFFF",
      marginBottom: 28,
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 20,
      minHeight: 120,
      boxSizing: "border-box",
      [theme.breakpoints?.down("sm")]: {
        padding: "20px 18px",
        borderRadius: 16,
        minHeight: "auto",
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: "-40%",
        right: "-10%",
        width: 300,
        height: 300,
        background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
        pointerEvents: "none",
      },
      "& >h6": {
        color: "#FFFFFF !important",
        fontSize: "1.75rem !important",
        fontWeight: "800 !important",
        margin: "0 !important",
        position: "relative !important",
        left: "auto !important",
        top: "auto !important",
        bottom: "auto !important",
        zIndex: 2,
        [theme.breakpoints?.down("sm")]: {
          fontSize: "1.25rem !important",
        },
      },
    },
  }));
  const {t} = useTranslation();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchCategoryList());
  }, [dispatch]);

  return (
    <Box>
      <Box className={classes.background}>
        <Typography variant="subtitle2">{t("managerCategory.danhsachchude")}</Typography>
        <AddCategory />
      </Box>

      {/* Table */}
      <TableCategory />
    </Box>
  );
}
